<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      
      <template #start>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSearchChange">
        </CompositeFormDate>
      </template>
      
      <!-- 导出按钮 -->
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`运费统计表`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" >
      <template slot="standard" slot-scope="params">
        <div v-if="params.params.pricing == 1" class="overTime type0">
          按重量计费
        </div>
        <div v-if="params.params.pricing == 2" class="overTime type1">
          按体积计费
        </div>
        <div v-if="params.params.pricing == 3" class="overTime type2">
          按件数计费
        </div>
        <div v-if="params.params.pricing == 4" class="overTime type3">
          按里程计费
        </div>
        <div v-if="params.params.pricing == 5" class="overTime type4">
          按趟计费
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "FinanceFeightStatistics",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'order',
      breadcrumb: [
        { name: "财务管理", path: `/finance/feightStatistics` },
        { name: "运费统计表", path: `/finance/feightStatistics` },
      ],
      formInline: {
        date: "",
        fleet: "",
        license: "",
        pname: "",
        driver: "",
      },
      searchDateOptions: [
        { ...this.ctrls.ZhuangHuoRiQi, },
        { ...this.ctrls.XieHuoRiQi, },
      ],
      formCtrl: [
        {
          ...this.ctrls.fleet,
          options: [],
        },
        {
          ...this.ctrls.license,
        },
        {
          label: "客户名称",
          keyName: "pname",
          placeholder: "请填写客户名称",
          type: "text",
        },
        // {
        //   label: "司机：",
        //   keyName: "driver",
        //   placeholder: "请填写司机姓名",
        //   type: "text",
        // },
      ],
      cols: [
        { keyName: "order_num", label: "运单编号", minwidth: 140 },
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 120 },
        { keyName: "shname", label: "客户名称" , minwidth: 150},
        { keyName: "name", label: "货物名称" , minwidth: 120},
        { keyName: "pricing", label: "计价方式", minwidth: 120, slot: 'standard' },
        { keyName: "coaddress", label: "装货地址", minwidth: 150 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 150 },

        { ...this.ctrls.ZhuangHuoRiQi, minwidth: 120 },
        { ...this.ctrls.XieHuoRiQi, minwidth: 120 },

        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        
        { keyName: "kuiton", label: "亏吨重量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "ceton", label: "客担亏吨", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dtonprice", label: "亏吨单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dtonprices", label: "亏吨金额", align: 'right', className: 'pr30', minwidth: 120 },
        
        { keyName: "cprice", label: "公司单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "freight", label: "公司运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dprice", label: "司机单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dfreight", label: "司机运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dtotal", label: "出车费用", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "additional", label: "附加费用", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "compen", label: "补差金额", align: 'right', className: 'pr30', minwidth: 120 },
        //{ keyName: "premium", label: "保险费", align: 'right', className: 'pr30', minwidth: 120 },
        //{ keyName: "fuel", label: "燃油附加费", align: 'right', className: 'pr30', minwidth: 120 },
        //{ keyName: "overlimit", label: "超限附加费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "profit", label: "运单毛利额", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      getTotalProperty: ['inton', 'unton', 'kuiton', 'dtonprices', 'additional', 'freight', 'dfreight', 'dtotal', 'compen', 'profit'],
      getListUrl: 'freightrec',
    };
  },
  methods: {},
  // watch: {
  //   formCtrl: {
  //     deep: true,
  //     handler() {
  //       // console.log(newVal)
  //       const { fleetIdx } = this.$route.query
  //       this.formInline.fleet = this.formCtrl[1].options[fleetIdx].value
  //       this.$nextTick(this.getList)
  //     },
  //   }
  // },
  mounted() {
    this.getFleet()
  },
};
</script>
<style lang="less" scoped>
/deep/ .fillet .el-form--inline .el-form-item:nth-child(2) {
  margin-right: 0px;
  padding-right: 80px;
  position: relative;

  &::after {
    position: absolute;
    content: "";
    right: 40px;
    top: 6px;
    width: 1px;
    height: 28px;
    overflow: hidden;
    background-color: #EBEDF0;
  }
}
</style>